module.exports = __webpack_public_path__ + "img/en_EN.0907196a.png";